import { getMWLURL, getMetabaseURL } from ".";
import { getBackendURL } from "./axiosConnect";

export const replaceHostName = (url, type) => {
  let authorityRegex = /^https?:\/\/[a-z0-9A-Z.\-:]+/;

  const backendUrl = getBackendURL();
  try {
    if (type == 'viewer') {
      authorityRegex = /^dicomweb:https?:\/\/[a-z0-9A-Z.\-:]+/;
      return url.replace(authorityRegex, `dicomweb:${backendUrl}`);
    }
    if (type == 'metabase') {
      const metabaseUrl = getMetabaseURL();
      authorityRegex = /^http?:\/\/[a-z0-9A-Z.\-:]+/;
      return url.replace(authorityRegex, metabaseUrl);
    }
    if (type == 'mwl') {
      const metabaseUrl = getMWLURL();
      // On tablets the app is served over https, so the host authority starts
      // with "https://". The default `http?` regex below doesn't match "https://"
      // and leaves the URL host unswapped, so the /patient/add call never reaches
      // the MWL host. Use the protocol-agnostic regex for tablet viewports.
      const isTablet =
        typeof window !== "undefined" &&
        window.matchMedia("(max-width: 767px)").matches;
      authorityRegex = isTablet
        ? /^https?:\/\/[a-z0-9A-Z.\-:]+/
        : /^http?:\/\/[a-z0-9A-Z.\-:]+/;
      return url.replace(authorityRegex, metabaseUrl);
    }
    return url.replace(authorityRegex, backendUrl);
  } catch (e) {
    return "";
  }
};
